
// Constants for mobile configuration
export const MOBILE_CONFIG = {
  BREAKPOINT: 768,
  TOUCH_AREA_SIZE: 48, // Minimum touch target size in pixels (WCAG recommendation)
  DEFAULT_CONTROLS_OPACITY: 0.8,
  VIBRATION_DURATION: 20, // Short vibration for button presses (in ms)
};
